import { useTranslation } from 'react-i18next'

import { Namespace } from '~/i18n'
import { CardsWithTitle } from '~/components/cards-with-title'
import { sourcesOfBurns } from '~/data'

export function BurnsSourcesOfBurns() {
  const { t } = useTranslation([Namespace.BURNS])

  return (
    <CardsWithTitle
      title={t('sources-of-burns.title')}
      cards={sourcesOfBurns(t)}
    />
  )
}
